import { environment } from "../../../environments/environment";
import * as CryptoJS from "crypto-js";

export class AESEncrypt {
  private key = CryptoJS.enc.Utf8.parse(environment.aesKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.aesIV);

  // Se mantiene de momento el constructor vacío
  constructor() {}

  public encrypt(input: string): string {
    const encrypted = CryptoJS.AES.encrypt(input, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  public decrypt(input: string): string {
    const decrypted = CryptoJS.AES.decrypt(input, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  public encryptModel(input: any): any {
    var content = JSON.stringify(input);
    content = this.encrypt(content);
    return content;
  }

  public decryptModel(input: string): any {
    const content = input == null? '[]' : this.decrypt(input);
    return JSON.parse(content);
  }
}
